// Externe Bibliotheken
import React, { Component } from 'react';
import axios from 'axios';

// Interne Module
import * as storage from '@/_helper/storage';
import tracking from '@/_helper/tracking';
import { convertPrice } from '@/_helper/mapper';
import { checkTripStarts } from '@/_helper/checkTripStarts.jsx';
import { checkIsAllowToBookService } from '@/_helper/checkAccess';
import getDurationDays, { getShortWeekday, mapRooms } from '@/_helper/bookingDetailsHelper';
import { buildGetRequest, buildPostRequest } from '@/_helper/apiHelper';
import { AppContext } from '@/context/AppContext.tsx';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';
import StatusPage from '@/comp/statusPage/statusPage';
import Button from '@/comp/button/button.tsx';
import Icon from '@/comp/icon/icon.tsx';
import InfoCard from '@/comp/ui/infoCard/infoCard.tsx';

// Styles
import './cancellation.scss';

const params = {
    errorWording: {
        accept: 'Bitte bestätigen Sie, dass Sie die AGB und die Zahlungs- und Stornierungsbedingungen gelesen und zur Kenntnis genommen haben!',
    },
};

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageLoad: false,
            data: {},
            bookingId: storage.get('bookingNumber') ? storage.get('bookingNumber') : '',
            formErrors: {
                accept: '',
            },
            acceptCheckbox: false,
            formValid: false,
            formVacancy: false,
            success: false,
            alreadyTested: false,
            trackData: true,
        };

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    static contextType = AppContext;

    componentDidMount() {
        document.title = 'Stornierung' + window.$documentTitle;
        document.querySelector('html').classList.add('redesign');

        if (
            checkIsAllowToBookService('Cancellation') &&
            storage.get('bookingData') != null &&
            storage.get('bookingData').data != null &&
            !checkTripStarts()
        ) {
            let data = storage.get('bookingData').data;
            this.setState((state) => {
                state.data = data;
                state.success = data.bookingCancelled ? data.bookingCancelled : false;
                state.pageState = data.bookingCancelled ? 'success' : 'loading';
                state.pageLoad = data.bookingCancelled !== undefined ? data.bookingCancelled : '';
                return state;
            });

            if (!data.bookingCancelled) {
                checkIsAllowToBookService('Cancellation');
                tracking('loaded', 'cancellation');
                this.requestCancellation();
            }
        } else {
            setTimeout(() => {
                window.location.href = '#/';
            }, 0);
        }
    }

    requestCancellation() {
        axios(
            buildGetRequest(window.$serviceUrl, '/cancellationcosts', {
                requestType: 'cancellationcosts',
                clientId: 'customerarea',
                bookingid: this.state.bookingId,
            })
        )
            .then((response) => response)
            .then((data) => {
                let cancelPaymentInformation = data.data?.data?.paymentCancellationPolicy;
                let cancellationParams = {};
                let cancelled;

                // set situational error messages -> StatusPage : error
                let cancellationErrorInfo = cancelPaymentInformation?.cancellationErrorInfo;
                let cancellationInfoText = cancelPaymentInformation?.cancellationInfoText;

                if (cancellationErrorInfo || cancellationInfoText) {
                    let errorCase = null;
                    switch (true) {
                        //  already cancelled
                        case cancellationErrorInfo?.includes('Booking is already cancelled'):
                            errorCase = 'alreadyCancelled';
                            break;
                        // package price not given || request by phone
                        case cancellationErrorInfo?.includes('package price not given'):
                        case cancellationInfoText?.includes('Stornokosten bitte bei AurumTours telefonisch anfragen'):
                            errorCase = 'contactCustomerService';
                            break;
                        //  travel start already done
                        case cancellationErrorInfo?.includes('Die Reise hat bereits begonnen oder ist abgeschlossen'):
                        case cancellationErrorInfo?.includes('Die Reise ist abgeschlossen'):
                            errorCase = 'travelStartAlreadyDone';
                            break;
                        default:
                    }

                    if (errorCase) {
                        this.setState({
                            pageState: 'error',
                            errorCase: errorCase,
                        });

                        return false;
                    }
                }

                if (cancelPaymentInformation !== undefined && cancelPaymentInformation.haveCancellationInfo) {
                    const servicesMediated = cancelPaymentInformation.servicesMediated;
                    const crisisCancel = data.data.data.crisisCancel;
                    const goodWillCancel = data.data.data.goodWillCancel;

                    cancelled = data.data.data.bookingInformation.cancelled;

                    cancellationParams['cancellationPrice'] = this.getCancellationPrice(cancelPaymentInformation);
                    cancellationParams['crisisCancel'] = crisisCancel;
                    cancellationParams['goodWillCancel'] = goodWillCancel;
                    cancellationParams['cancelled'] = cancelled;
                    cancellationParams['mediatedServicesCancel'] = servicesMediated;

                    this.setState((state) => {
                        state.data.cancellationParams = cancellationParams;
                        state.pageLoad = true;
                        state.pageState = cancelled ? 'success' : 'loaded';
                        state.success = cancelled;
                        return state;
                    });
                } else {
                    this.setState({
                        error: true,
                        pageState: 'error',
                        pageLoad: true,
                        trackData: false,
                    });
                }
            })
            .catch(() => {
                this.setState({
                    pageLoad: false,
                    pageState: 'error',
                    trackData: true,
                });
            });
    }

    handleCheckboxChange(name) {
        if (Object.keys(this.state).includes(name)) {
            let checkboxValue = this.state[name];

            this.setState(
                {
                    [name]: !checkboxValue,
                },
                () => {
                    this.validateField(name, checkboxValue);
                }
            );
        }
    }

    validateField(fieldName) {
        let fieldValidationErrors = this.state.formErrors;
        let acceptValid = this.state.acceptValid;

        switch (fieldName) {
            case 'acceptCheckbox':
                acceptValid = this.state[fieldName];
                fieldValidationErrors.accept = acceptValid ? '' : params.errorWording.accept;
                break;
            default:
                break;
        }

        this.setState({ formErrors: fieldValidationErrors, acceptValid: acceptValid }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.acceptValid });
    }

    handleSubmit(event) {
        event.preventDefault();
        tracking('interaction', 'cancellation');

        this.setState({
            error: false,
            alreadyTested: true,
        });

        // form validation
        this.validateField('acceptCheckbox');

        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            // set error dialogs
            let fieldValidationErrors = this.state.formErrors;
            fieldValidationErrors.accept = params.errorWording.accept;

            this.setState({
                formErrors: fieldValidationErrors,
            });

            return;
        }
        // form is valid!

        let sendParams;
        if (this.state.bookingId && this.state.data.searchParams && this.state.data.searchParams.travelType) {
            sendParams = {
                clientId: 'customerarea',
                bookingId: this.state.bookingId,
                travelType: this.state.data.searchParams.travelType,
                requestType: 'cancelBooking',
                requestSource: 'customerarea',
            };
        }

        this.setState({
            formVacancy: true,
        });

        if (sendParams === undefined) {
            return;
        }

        axios(buildPostRequest(window.$serviceUrl, '/cancelBooking', sendParams))
            .then((response) => response)
            .then((response) => {
                let success = response.data?.data?.cancellationResult === 'cancelled';

                if (success) {
                    let bookingData = storage.get('bookingData');

                    if (bookingData && bookingData.data) {
                        bookingData.data.bookingCancelled = true;
                        storage.set('bookingData', bookingData);
                    }

                    // set
                    this.setState({
                        pageState: 'success',
                        formVacancy: false,
                        success: true,
                        trackData: true,
                    });
                } else {
                    this.setState({
                        pageState: 'error',
                        formVacancy: false,
                        trackData: true,
                    });
                }
            })
            .catch(() => {
                this.setState({
                    pageState: 'error',
                    formVacancy: false,
                    trackData: true,
                });
            });
    }

    getMediatedServicesWithDetails(mediatedServicesCancel) {
        const { frontendParams: { mediatedServices = {}, postPayServices = {}, price = {} } = {} } = this.state.data;

        const serviceMapping = {
            accommodation: 'Unterkunft',
            transport: 'Flug',
            cruise: 'Kreuzfahrt',
            insurance: 'Versicherung',
        };
        const cancellationMapping = {
            accommodation: 'hotel',
            transport: 'flight',
            cruise: 'cruise',
            insurance: 'insurance',
        };

        return Object.entries(mediatedServices)
            .filter(([, value]) => value === true)
            .map(([serviceKey]) => {
                const cancellationKey = cancellationMapping[serviceKey] ?? serviceKey;
                const cancellationServices = mediatedServicesCancel?.[cancellationKey];
                let cancellationPrice;

                if (typeof cancellationServices === 'object' && !Array.isArray(cancellationServices)) {
                    for (const service of Object.values(cancellationServices)) {
                        if (Object.hasOwnProperty.call(service, 'currentCancellationPrice')) {
                            cancellationPrice = service.currentCancellationPrice;
                        }
                    }
                }

                return {
                    key: serviceKey,
                    label: serviceMapping[serviceKey] ?? serviceKey,
                    cancellationPrice,
                    originalPrice: price?.mediatedPrice,
                    isPostPay: postPayServices[serviceKey],
                };
            });
    }

    getCancellationPrice(cancelPaymentInformation) {
        let packageCancellationPrice = cancelPaymentInformation.customer.currentCancellationPrice;
        let mediatedCancellationPrice = 0;

        if (this.hasMediatedServices()) {
            this.getMediatedServicesWithDetails(cancelPaymentInformation.servicesMediated).forEach(
                ({ cancellationPrice: servicePrice }) => {
                    if (servicePrice) {
                        mediatedCancellationPrice += servicePrice;
                    }
                }
            );
        }

        return {
            package: packageCancellationPrice,
            mediated: mediatedCancellationPrice,
            total: packageCancellationPrice + mediatedCancellationPrice,
        };
    }

    getActiveCount(arr) {
        return arr?.filter((item) => item.state === 'OK').length ?? 0;
    }

    hasActiveExcursions() {
        const { excursions } = this.state.data?.frontendParams ?? {};
        return excursions && this.getActiveCount(excursions) > 0;
    }

    hasActiveSeatReservation() {
        const { bookedSeats } = this.state.data?.serviceInformation ?? {};
        return bookedSeats && this.getActiveCount(bookedSeats) > 0;
    }

    hasMediatedServices() {
        const { mediatedServices } = this.state.data?.frontendParams ?? {};
        return mediatedServices && Object.values(mediatedServices).some((value) => value === true);
    }

    hasPostPayServices() {
        const { postPayServices } = this.state.data?.frontendParams ?? {};
        return postPayServices && Object.values(postPayServices).some((value) => value === true);
    }

    travelOverview() {
        const { data } = this.state;

        const hotelDetails = data.frontendParams?.hotelDetails?.[0] ?? null;
        const flightDetails = data.frontendParams?.flightDetails ?? null;
        const cruiseDetails = data.frontendParams?.cruise ?? null;

        const hotel = (hotelDetails) => {
            const travelDuration = getDurationDays(hotelDetails?.checkIn, hotelDetails?.checkOut);

            const Stars = ({ category }) => {
                const count = Number.parseInt(category, 10);
                if (!Number.isFinite(count) || count <= 0) {
                    return null;
                }
                return (
                    <span className="stars" role="img" aria-label={`${hotelDetails.category} von 5 Sternen`}>
                        {Array.from({ length: count }, (_, i) => (
                            <Icon key={`star-${i}`} name="starFilled" size={20} ariaHidden />
                        ))}
                    </span>
                );
            };

            return (
                <>
                    <div className="element hotel-name">
                        <Icon name="locationAway300" ariaHidden />
                        <div>
                            {hotelDetails.name}
                            {hotelDetails.category && <Stars category={hotelDetails.category} />}
                        </div>
                    </div>
                    <div className="element">
                        <Icon name="location300" ariaHidden />
                        <div>
                            {hotelDetails.address1}
                            {hotelDetails.address2?.length > 0 && ', ' + hotelDetails.address2}
                            {hotelDetails.address3?.length > 0 && ', ' + hotelDetails.address3}
                            {hotelDetails.address4?.length > 0 && ', ' + hotelDetails.address4}
                        </div>
                    </div>
                    <div className="element">
                        <Icon name="bed300" ariaHidden />
                        <div>
                            <div>
                                {`${travelDuration} ${travelDuration === 1 ? 'Nacht' : 'Nächte'}`} vom{' '}
                                {hotelDetails.checkIn} bis {hotelDetails.checkOut}
                            </div>
                            {mapRooms(hotelDetails.rooms)?.map((item, index) => {
                                return (
                                    <div key={index}>
                                        {item?.count > 1 || hotelDetails.rooms?.length > 1 ? `${item.count} ` : ''}
                                        {item?.name}&nbsp;&middot;&nbsp;{item?.meal}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </>
            );
        };

        const cruise = (cruiseDetails) => {
            const rooms = cruiseDetails.room?.details ?? [];

            return (
                <div className="element cruise">
                    <Icon name="directionsBoat300" ariaHidden />
                    <div>
                        {cruiseDetails.shipName && <p>Schiff: {cruiseDetails.shipName}</p>}
                        {cruiseDetails.checkIn && cruiseDetails.checkOut && (
                            <p>
                                {getDurationDays(cruiseDetails.checkIn, cruiseDetails.checkOut)} Nächte vom{' '}
                                {cruiseDetails.checkIn} bis {cruiseDetails.checkOut}
                            </p>
                        )}
                        {rooms &&
                            mapRooms(rooms).map((room, index) => (
                                <p key={index}>
                                    {room?.count > 1 ? `${room?.count} ` : ''}
                                    {room?.name}&nbsp;&middot;&nbsp;{room?.meal}
                                </p>
                            ))}
                    </div>
                </div>
            );
        };

        const flight = (flightDetails) => {
            const flightElement = (flight) => (
                <div key={`flight-${flight.flightNumber}`}>
                    {`${getShortWeekday(flight.depDate)}., ${flight.depDate}`}
                    &nbsp;&middot;&nbsp;
                    {`${flight.depAirportDescription} (${flight.depAirportCode}) - ${flight.arrAirportDescription} (${flight.arrAirportCode})`}
                </div>
            );

            return (
                <>
                    {flightDetails.outbound && (
                        <div className="element flight-outbound">
                            <Icon name="flight300" ariaHidden />
                            <div>{flightDetails.outbound.map((flight) => flightElement(flight))}</div>
                        </div>
                    )}
                    {flightDetails.inbound && (
                        <div className="element flight-inbound">
                            <Icon name="flight300" ariaHidden />
                            <div>{flightDetails.inbound.map((flight) => flightElement(flight))}</div>
                        </div>
                    )}
                </>
            );
        };

        const participants = ({ adults, children, babies }) => {
            children = children + babies;

            return (
                <div className="element">
                    <Icon name="howToReg300" ariaHidden />
                    <div>
                        <>{`${adults} ${adults === 1 ? 'Erwachsener' : 'Erwachsene'}`}</>
                        {children > 0 && (
                            <>
                                &nbsp;&middot;&nbsp;
                                {`${children} ${children === 1 ? 'Kind' : 'Kinder'}`}
                            </>
                        )}
                    </div>
                </div>
            );
        };

        const extraServices = ({ transfer, railAndFly }, excursions) => {
            const activeExcursionCount = this.getActiveCount(excursions ?? []);

            return (
                <>
                    {this.hasActiveExcursions() && (
                        <div className="element">
                            <Icon name="attractions300" ariaHidden />
                            <div>
                                Mit {activeExcursionCount === 1 ? 'Ausflug' : `${activeExcursionCount} Ausflügen`}
                            </div>
                        </div>
                    )}
                    {this.hasActiveSeatReservation() && (
                        <div className="element">
                            <Icon name="airlineSeat300" ariaHidden />
                            <div>Mit Sitzplatzreservierung (Flug)</div>
                        </div>
                    )}
                    {transfer && (
                        <div className="element">
                            <Icon name="airportShuttle300" ariaHidden />
                            <div>Mit Transfer</div>
                        </div>
                    )}
                    {railAndFly?.length > 0 && (
                        <div className="element">
                            <Icon name="train300" ariaHidden />
                            <div>Mit Rail & Fly</div>
                        </div>
                    )}
                </>
            );
        };

        return (
            <section className="travel-overview">
                {hotelDetails && hotel(hotelDetails)}
                {cruiseDetails && cruise(cruiseDetails)}
                {participants(data.searchParams)}
                {flightDetails && flight(flightDetails)}
                {extraServices(data.serviceInformation, data.frontendParams?.excursions)}
            </section>
        );
    }

    cancellationOverview() {
        const { data } = this.state;
        const { cancellationParams } = data;

        if (!cancellationParams) {
            return null;
        }
        const { cancellationPrice, crisisCancel, mediatedServicesCancel } = cancellationParams;
        const { frontendParams: { mediatedServices = {}, postPayServices = {} } = {} } = data;

        const mainPackagePrice = (packages) => {
            let price = 0;
            const validPackage = (key) =>
                key.startsWith('AUR') ||
                key.startsWith('AT') ||
                (this.context.travelType === 'cruise' && key.startsWith('CRUISE'));

            for (const [key, value] of Object.entries(packages)) {
                if (validPackage(key)) {
                    price += Number(value);
                }
            }
            return convertPrice(price);
        };

        const infoText = {
            ch24pay:
                'Bereits geleistete Zahlungen werden nach Verrechnung der Stornierungskosten durch Check24 Vergleichsportal Hotel GmbH erstattet. Weitere Informationen zur Erstattung erhalten Sie von Check24 Vergleichsportal Hotel GmbH.',
            default:
                'Bereits geleistete Zahlungen an AurumTours werden mit Ihren Stornierungskosten verrechnet und ggf. mit der bei Buchung angegebenen Zahlungsmethode erstattet.',
        };

        const accServicePrices = (service) => {
            return convertPrice(service?.map((item) => item.price)?.reduce((acc, curr) => acc + curr));
        };

        const packageSummary = ({ transfer, railAndFly }, packageDetails) => {
            return (
                <div className="element">
                    <Icon name="beachAccess300" ariaHidden />
                    <div className="package-type">
                        Reise{' '}
                        {transfer && railAndFly?.length > 0 ? (
                            <>inkl. Transfer und Rail & Fly</>
                        ) : transfer ? (
                            <>inkl. Transfer</>
                        ) : railAndFly?.length > 0 ? (
                            <>inkl. Rail & Fly</>
                        ) : null}
                    </div>
                    {packageDetails && <div>{mainPackagePrice(packageDetails)}</div>}
                </div>
            );
        };

        const excursions = (excursions) => {
            return (
                <div className="element">
                    <Icon name="attractions300" ariaHidden />
                    <div className="package-type">{this.getActiveCount(excursions) === 1 ? 'Ausflug' : 'Ausflüge'}</div>
                    <div>{accServicePrices(excursions)}</div>
                </div>
            );
        };

        const seatReservation = (bookedSeats) => {
            return (
                <div className="element">
                    <Icon name="airlineSeat300" ariaHidden />
                    <div className="package-type">
                        {this.getActiveCount(bookedSeats) === 1 ? 'Sitzplatzreservierung' : 'Sitzplatzreservierungen'}
                    </div>
                    <div>{accServicePrices(bookedSeats)}</div>
                </div>
            );
        };

        const mediatedServicesWithDetails = this.getMediatedServicesWithDetails(mediatedServicesCancel);

        const mediated = () => {
            const mediatedService = mediatedServicesWithDetails[0];
            if (!mediatedService) {
                return null;
            }
            const { label, originalPrice } = mediatedService;

            return (
                <div className="element no-icon">
                    <div className="package-type">{label} (vermittelte Leistung)</div>
                    {originalPrice && <div>{convertPrice(originalPrice)}</div>}
                </div>
            );
        };

        const mediatedServiceInfoCards = () => {
            return (
                <>
                    {mediatedServices.accommodation && (
                        <InfoCard>
                            <div>
                                AurumTours reicht Ihren Stornierungsauftrag an den{' '}
                                <span className="text-bold">Leistungsträger</span> weiter. Sie müssen Ihre Unterkunft{' '}
                                <span className="text-bold">nicht zusätzlich</span> kontaktieren.
                                {postPayServices.accommodation &&
                                    (cancellationPrice.total === 0 ? (
                                        <>
                                            {' '}
                                            Bereits geleistete Zahlungen an den Leistungsträger werden auf die
                                            ursprüngliche Zahlungsmethode erstattet.
                                        </>
                                    ) : (
                                        <>
                                            <br />
                                            Anfallende Stornierungskosten der vermittelten Leistung zahlen Sie mit Ihrer
                                            ursprünglichen Zahlungsmethode direkt an die Unterkunft.
                                        </>
                                    ))}
                            </div>
                        </InfoCard>
                    )}
                    {(mediatedServices.transport || postPayServices.transport) && (
                        <InfoCard>
                            <div>
                                Sie <span className="text-bold">stornieren</span> nur Ihr{' '}
                                <span className="text-bold">Reisepaket</span> bei AurumTours. Bitte beachten Sie, dass
                                Ihre Flugleistung laut den Stornierungsbedingungen des Leistungsträgers{' '}
                                <span className="text-bold">nicht stornierbar</span> ist. Der Flug bleibt daher
                                weiterhin aktiv und ist nicht stornierbar.
                            </div>
                        </InfoCard>
                    )}
                    {mediatedServices.cruise && (
                        <InfoCard>
                            <div>
                                AurumTours reicht Ihren Stornierungsauftrag an den{' '}
                                <span className="text-bold">Leistungsträger</span> weiter. Sie müssen Ihre Reederei{' '}
                                <span className="text-bold">nicht zusätzlich</span> kontaktieren.
                                {postPayServices.cruise && (
                                    <>
                                        {' '}
                                        Die angezeigten Stornierungskosten wurden auf Basis der uns vorliegenden
                                        Tarifinformationen berechnet und dienen zur Orientierung. Die endgültigen und
                                        verbindlichen Stornierungskosten der vermittelten Leistung entnehmen Sie bitte
                                        der Stornorechnung der Reederei.
                                    </>
                                )}
                            </div>
                        </InfoCard>
                    )}
                </>
            );
        };

        const mediatedServicesCancellationCosts = () => {
            const pricedMediatedServices = mediatedServicesWithDetails.filter(
                ({ cancellationPrice }) => typeof cancellationPrice === 'number'
            );

            if (pricedMediatedServices.length === 0 || cancellationPrice.total === 0 || !this.hasPostPayServices()) {
                return null;
            }

            return pricedMediatedServices
                .filter(({ isPostPay }) => isPostPay)
                .map(({ key, label, cancellationPrice, isPostPay }) => {
                    return (
                        isPostPay && (
                            <div className="price" key={key}>
                                <div>
                                    Stornierungskosten vermittelte Leistung
                                    {pricedMediatedServices.length > 1 ? ` (${label})` : ''}
                                </div>
                                <div>
                                    {convertPrice(cancellationPrice, Number.isInteger(cancellationPrice) ? 0 : 2, 2)}
                                </div>
                            </div>
                        )
                    );
                });
        };

        return (
            <section className="cancellation-overview">
                <div>
                    <h3>Gesamtkosten</h3>
                    {packageSummary(data?.serviceInformation, data.frontendParams?.price?.packageDetails)}
                    {this.hasActiveExcursions() && excursions(data?.frontendParams?.excursions)}
                    {this.hasActiveSeatReservation() && seatReservation(data?.serviceInformation?.bookedSeats)}
                    {this.hasMediatedServices() && mediated()}
                </div>
                <div>
                    {mediatedServiceInfoCards()}
                    <hr />
                    <div className="refund-info">
                        {data.frontendParams.paymentDetails.type === 'ch24pay'
                            ? infoText[data.frontendParams.paymentDetails.type]
                            : infoText['default']}
                    </div>
                    {this.hasActiveSeatReservation() && (
                        <div className="info seat-reservation">
                            <Icon name="info" size={20} ariaHidden />
                            Kosten für reservierte Sitzplätze können nicht erstattet werden.
                        </div>
                    )}
                    <div className={`cancellation-cost${cancellationPrice.total === 0 ? ' free-cancellation' : ''}`}>
                        <div className="price">
                            <div>
                                {this.hasMediatedServices() && cancellationPrice.package !== 0
                                    ? 'Stornierungskosten AurumTours'
                                    : 'Stornierungskosten'}
                            </div>
                            <div>{`${convertPrice(cancellationPrice.package, 0, 2)}`}</div>
                        </div>
                        {this.hasMediatedServices() && mediatedServicesCancellationCosts()}
                        {(crisisCancel === true || cancellationPrice.total !== 0) && (
                            <div className="info">
                                <Icon name="info" ariaHidden size={20} />
                                {crisisCancel === true ? (
                                    <>
                                        Aufgrund der aktuellen Situation ermöglicht AurumTours eine kostenlose
                                        Stornierung der Reise.
                                    </>
                                ) : cancellationPrice.total !== 0 ? (
                                    <>
                                        Die Stornierungskosten entsprechen der Stornierungs&shy;kategorie Ihrer
                                        Reisebuchung.
                                        {this.hasMediatedServices() && (
                                            <>
                                                {window.$browserInfo.device === 'mobile' ? <br /> : ' '}
                                                Für die vermittelte Leistung gelten die Stornierungs&shy;bedingungen des
                                                Leistungsträgers.
                                            </>
                                        )}
                                    </>
                                ) : null}
                            </div>
                        )}
                    </div>
                </div>
            </section>
        );
    }

    userAction() {
        const { data } = this.state;

        const termsUrl = `${window.$website}/unternehmen/${this.context?.travelType === 'cruise' ? 'agb-kreuzfahrten' : 'agb'}`;

        return (
            <section className="accept-sec">
                <div className="checkbox-input">
                    <input
                        id="acceptCheckbox"
                        name="acceptCheckbox"
                        type="checkbox"
                        checked={this.state.acceptCheckbox}
                        onChange={() => this.handleCheckboxChange('acceptCheckbox')}
                    />
                    <span className="icon" onClick={() => this.handleCheckboxChange('acceptCheckbox')}></span>
                    <label htmlFor="acceptCheckbox">
                        Ja, ich möchte meine Reise jetzt stornieren. Ich akzeptiere die{' '}
                        <a href={termsUrl} target="_blank" rel="noopener noreferrer">
                            Allgemeinen Geschäftsbedingungen
                        </a>{' '}
                        sowie die{' '}
                        <a href={termsUrl} target="_blank" rel="noopener noreferrer">
                            Zahlungs- und Stornierungsbedingungen
                        </a>{' '}
                        der AurumTours GmbH.
                    </label>
                </div>
                {this.state.acceptValid === false &&
                    this.state.alreadyTested &&
                    this.state.formErrors.accept.length > 0 && (
                        <div className="error">{this.state.formErrors.accept}</div>
                    )}

                <Button
                    valid={this.state.formValid}
                    validated={this.state.formVacancy}
                    type="submit"
                    label={
                        this.state.formVacancy
                            ? 'Daten werden übermittelt'
                            : data.cancellationParams.cancellationPrice.total === 0
                              ? 'Jetzt kostenlos stornieren'
                              : `Jetzt für ${convertPrice(data.cancellationParams.cancellationPrice.total, Number.isInteger(data.cancellationParams.cancellationPrice.total) ? 0 : 2, 2)} stornieren`
                    }
                    icon="arrowForward"
                />

                <small className="txtR">Sie erhalten im Anschluss eine Stornierungsbestätigung per E-Mail.</small>

                {this.state.error === true && <div className="error txtR">{window.$content.errorText}</div>}
            </section>
        );
    }

    render() {
        const { data } = this.state;

        const cancellationForm = () => {
            const title =
                this.context?.travelType === 'cruise'
                    ? 'Meine Kreuzfahrt'
                    : `Meine Reise nach ${data.frontendParams.hotelDetails[0]?.areaDescription}`;

            return (
                <form
                    className={this.state.formVacancy ? 'validate' : ''}
                    onSubmit={this.handleSubmit}
                    onChange={() => tracking('interaction', 'cancellation')}>
                    <h2>{title}</h2>
                    <div className="content">
                        {this.travelOverview()}
                        {this.cancellationOverview()}
                        {this.userAction()}
                    </div>
                </form>
            );
        };

        const skeleton = () => {
            return (
                <div className="loading lazy-load-background">
                    <span className="headline" />
                    <div className="content">
                        <div>
                            <span className="element" />
                            <span className="element" />
                            <span className="element" />
                        </div>
                        <div>
                            <span className="element" />
                            <span className="element" />
                        </div>
                    </div>
                </div>
            );
        };

        return (
            <div className="page-cancellation">
                <Header />

                {this.state.pageState === 'success' ? (
                    <StatusPage type="success" subPage="cancellation" />
                ) : this.state.pageState === 'error' ? (
                    <StatusPage
                        type="error"
                        case={this.state.errorCase ? this.state.errorCase : false}
                        subPage="cancellation"
                        trackData={this.state.trackData}
                    />
                ) : (
                    <div className="content-wrapper">
                        <h1 className="main-headline">Gesamte Reise stornieren</h1>
                        <div className="subline">Hier können Sie schnell und einfach Ihre Reise stornieren.</div>

                        {this.state.pageLoad ? cancellationForm() : skeleton()}
                    </div>
                )}
                <Footer />
            </div>
        );
    }
}

export default Index;
